type OptionWithId<Value> = {
    id: Value;
};

export const getOptionsFromArray = <Value, Option extends OptionWithId<Value>>(
    values: ReadonlyArray<Value> | undefined,
    options: ReadonlyArray<Option>,
): ReadonlyArray<Value> => {
    if (values?.length === 0) {
        return options.map(({ id }) => id);
    }

    return values ?? [];
};

export const getValuesFromArray = <Value, Option>(
    values: ReadonlyArray<Value> | undefined,
    options: ReadonlyArray<Partial<Option>>,
): ReadonlyArray<Value> | undefined => {
    if (values?.length === options.length) {
        return [];
    }

    return values;
};
